import { Typography } from "@/components/atoms";
import { useGetClientProfileQuery } from "@/redux/apis/clientProfile/clientProfileApi";

/**
 * Persistent purple banner over the operator-scoped booking sheet (Figma 11220-125891),
 * naming the client the draft belongs to so the operator always knows whose booking it is.
 * Reads the same profile query the summary rail and Manage-Client shell use (deduped by RTK key).
 */
export const OperatorBookingBanner = ({ accountId }: { accountId: string }) => {
  const { data: profile } = useGetClientProfileQuery({ accountId });
  const name = [profile?.personal.first_name, profile?.personal.last_name].filter(Boolean).join(" ");

  return (
    <div className="shrink-0 bg-vivid-purple-dark px-3 py-2.5 lg:px-5">
      <Typography variant="action" className="text-white">
        Booking for client{name && `: ${name}`}
      </Typography>
    </div>
  );
};
